import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IAuctionBatchInfoProps {
  auctionCode: string;
  auctionDate: string;
  batchCode: string;
}

export const AuctionBatchInfo: React.FC<IAuctionBatchInfoProps> = ({
  auctionCode,
  auctionDate,
  batchCode,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box>
      {auctionCode && (
        <>
          <Text textTransform="uppercase">{t('QUOTE_DETAILS.BATCH_REF')}</Text>
          <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
            {batchCode}
          </Text>
          <Text>
            {auctionCode} <br /> {auctionDate}
          </Text>
        </>
      )}
    </Box>
  );
};
